import React from 'react';

const DateTo = ({ selectedDate, onDateChange, inputStyles, name }) => {
    return (
        <div className="mt-2">
            <input
                value={selectedDate}
                onChange={onDateChange}
                style={inputStyles}
                id="date"
                name={name}
                type="date"
                autoComplete="date"
                required
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
        </div>
    );
};

export default DateTo;
